import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { collocationsData, getDataForDifficulty } from '../courses/data/vocabulary/collocations';

export default function CollocationTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : collocationsData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
